import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Exclusão de bloqueio de agenda em /agenda-blocks/{id}.
export function useDeleteAgendaBlock() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((agendaBlockId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/agenda-blocks/${agendaBlockId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
